const sortMakeCodeQuery = (query) => {
    if (query.makeCode && Array.isArray(query.makeCode)) {
        query.makeCode = query.makeCode.sort();
    }
    return query;
};

export default sortMakeCodeQuery;
